import React, { Dispatch, FC, SetStateAction } from 'react';

import { CheckBoxText } from '../styles';
import FileDownloadLink from 'src/commons/components/FileDownloadLink';
import {
  LegalDocuments,
  COASTAL_BANK_PRIVACY_POLICY_URL,
} from 'src/commons/constants';

interface ESignCheckboxCopyProps {
  isNewTcpaEnabled: boolean;
  acceptedTcpa: boolean;
  formik: any;
  setShowTcpaModal: Dispatch<SetStateAction<boolean>>;
  getViewUrl: (documentName: string) => string;
  getDocumentTitle: (documentName: string) => string;
}

export const ESignCheckboxCopy: FC<ESignCheckboxCopyProps> = ({
  isNewTcpaEnabled,
  acceptedTcpa,
  formik,
  setShowTcpaModal,
  getViewUrl,
  getDocumentTitle,
}) => (
  <CheckBoxText id="esign-checkbox-text">
    I have read and agree by electronic signature to the above Terms and
    Conditions, the{' '}
    <FileDownloadLink
      href={getViewUrl(LegalDocuments.TERMS_OF_USE_AND_ELECTRONIC_CONSENT)}
      target="_blank"
    >
      {getDocumentTitle(LegalDocuments.TERMS_OF_USE_AND_ELECTRONIC_CONSENT)}
    </FileDownloadLink>
    , which includes your consent for us to send you emails about our products
    and services, the{' '}
    <FileDownloadLink
      href={getViewUrl(LegalDocuments.DATA_TERMS_OF_USE)}
      target="_blank"
    >
      {getDocumentTitle(LegalDocuments.DATA_TERMS_OF_USE)}
    </FileDownloadLink>
    ,{' '}
    <FileDownloadLink href={COASTAL_BANK_PRIVACY_POLICY_URL} target="_blank">
      {getDocumentTitle(LegalDocuments.COASTAL_COMMUNITY_BANK_PRIVACY_POLICY)}
    </FileDownloadLink>{' '}
    and{' '}
    <FileDownloadLink
      href={getViewUrl(LegalDocuments.PROSPER_PRIVACY_POLICY)}
      target="_blank"
    >
      {getDocumentTitle(LegalDocuments.PROSPER_PRIVACY_POLICY)}
    </FileDownloadLink>
    ,{' '}
    <FileDownloadLink
      href={getViewUrl(LegalDocuments.CREDIT_REPORT_AUTHORIZATION)}
      target="_blank"
    >
      {getDocumentTitle(LegalDocuments.CREDIT_REPORT_AUTHORIZATION)}
    </FileDownloadLink>
    {!isNewTcpaEnabled
      ? formik.values.hasConsentedToTcpa && (
          <>
            , and{' '}
            <FileDownloadLink
              href={getViewUrl(LegalDocuments.TCPA_AUTHORIZATION)}
              target="_blank"
            >
              {getDocumentTitle(LegalDocuments.TCPA_AUTHORIZATION)}
            </FileDownloadLink>
          </>
        )
      : acceptedTcpa && (
          <>
            . I have also read and agree to the{' '}
            <FileDownloadLink
              // Empty href so it's keyboard accessible
              href="#"
              onClick={(e) => {
                setShowTcpaModal(true);
                e.preventDefault();
              }}
            >
              {getDocumentTitle(LegalDocuments.TCPA_AUTHORIZATION)}
            </FileDownloadLink>
          </>
        )}
    .
  </CheckBoxText>
);
